import script from "./flightPackages.vue?vue&type=script&lang=ts&setup=true"
export * from "./flightPackages.vue?vue&type=script&lang=ts&setup=true"

import "./flightPackages.vue?vue&type=style&index=0&id=225ab480&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225ab480"]])

export default __exports__